import React from 'react';
import { Box, Flex, Text, Icon, useColorModeValue } from '@chakra-ui/react';
import { WarningTwoIcon, WarningIcon } from '@chakra-ui/icons';

interface WarningPanelProps {
  type: 'warning' | 'error';
  title: string;
  messages?: string[];
  children?: React.ReactNode;
}

const WarningPanel: React.FC<WarningPanelProps> = ({ type, title, messages, children }) => {
  // Always call hooks in the same order
  const warningBg = useColorModeValue('orange.50', 'orange.900');
  const errorBg = useColorModeValue('red.50', 'red.900');
  const warningBorder = useColorModeValue('orange.300', 'orange.400');
  const errorBorder = useColorModeValue('red.300', 'red.400');
  const warningText = useColorModeValue('orange.800', 'orange.200');
  const errorText = useColorModeValue('red.800', 'red.200');

  const bg = type === 'warning' ? warningBg : errorBg;
  const border = type === 'warning' ? warningBorder : errorBorder;
  const iconColor = type === 'warning' ? 'orange.400' : 'red.400';
  const textColor = type === 'warning' ? warningText : errorText;
  const IconComponent = type === 'warning' ? WarningTwoIcon : WarningIcon;

  return (
    <Box
      w="100%"
      textAlign="left"
      bg={bg}
      borderRadius="lg"
      borderWidth="1.5px"
      borderColor={border}
      p={4}
      mb={4}
      boxShadow="sm"
    >
      <Flex  mb={2}>
        <Icon as={IconComponent} color={iconColor} w={6} h={6} mr={2} />
        <Text fontWeight="bold" fontSize="lg" color={iconColor}>{title}</Text>
      </Flex>
      {messages && messages.length > 0 ? (
        <Box as="ul" pl={0} ml={0} style={{ listStyle: 'disc', listStylePosition: 'inside' }}>
          {messages.map((msg, idx) => (
            <Text as="li" key={idx} mb={1} color={textColor}>{msg}</Text>
          ))}
        </Box>
      ) : (
        <Text color={textColor}>{children}</Text>
      )}
    </Box>
  );
};

export default WarningPanel; 